export default class EventElevation {
	constructor() {
		this.parentClass = '.event-elevation';
		this.tab = this.parentClass + '__menu li span';
	}

	init() {
		$(document).on('ready', function() {
			$(this.parentClass + '__menu li span').each(function() {
				const id = $(this).data('id');
				$(this).attr('id', id);
			});
			$(this.parentClass + '__content').each(function() {
				const id = $(this).data('id');
				$(this).attr('id', id);
			});
		});

		$('body').on('click', this.tab, function(e) {
			const anchor = $(this)
				.attr('class');
			$('.' + anchor)
				.css('display', 'block')
				.siblings()
				.css('display', 'none');
			$(this)
				.addClass('active')
				.parent()
				.siblings()
				.find('span')
				.removeClass('active');
			e.preventDefault();
		});

        if (window.themeColours && window.themeColours.primary) {
            const rgbColour = window.themeColours.primary.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
                                    , (m, r, g, b) => '#' + r + r + g + g + b + b)
                            .substring(1).match(/.{2}/g)
                            .map(x => parseInt(x, 16));

            if ($('#elevationtheme').length) {
                $('#elevationtheme feColorMatrix').attr('values', `${rgbColour[0] / 255} 0 0 0 0 0 ${rgbColour[1] / 255} 0 0 0 0 0 ${rgbColour[2] / 255} 0 0 0 0 0 1 0`);
            }
        }
	}
}
